import React, { useEffect, useState } from 'react';

const radioSelectorStyle = {
  container: {
    height: '27px',
    width: '200px',
    marginLeft: '25px',
    display: 'flex',
    boxSizing: 'border-box',
  },
  selected: {
    backgroundColor: '#fff',
    color: '#f18d2d',
  },
  notSelected: {
    cursor: 'pointer',
  },
};

const SelectorTypeDemandePassage = (props) => {
  const { leftValue, rightValue, profil } = props;
  const [value, setValue] = useState(props.value);

  // Gestion des appels API lors du changement de valeur du radio
  useEffect(() => {
    props.onChange(value);
  }, [value]);

  // Render du composant
  return (
    <div style={radioSelectorStyle.container}>
      <div
        className="radio-selector left-radio-selector"
        style={props.value === 'devis' ? radioSelectorStyle.selected : radioSelectorStyle.notSelected}
        onClick={() => setValue('devis')}
      >
        {leftValue}
      </div>
        {(profil.profil === 1 || profil.profil === 2 || profil.profil === 3) &&
            <>
                <div
                    className="radio-selector right-radio-selector"
                    style={props.value === 'facture' ? radioSelectorStyle.selected : radioSelectorStyle.notSelected}
                    onClick={() => setValue('facture')}
                >
                    {rightValue}
                </div>
            </>
        }
    </div>
  );
};

export default SelectorTypeDemandePassage;
